import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient, type UserProfileDto, type UserSettings } from '@/lib/apiClient';

export const userProfileKeys = {
  me: ['users', 'me'] as const,
};

/**
 * Fetch the current user's DB profile (includes theme, language, displayName).
 */
export const useCurrentUserProfileQuery = () =>
  useQuery({
    queryKey: userProfileKeys.me,
    queryFn: () => apiClient.getCurrentUserProfile(),
    staleTime: 60 * 1000, // 1 minute
  });

/**
 * Mutation to update the current user's settings.
 */
export const useUpdateUserSettingsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, settings }: { userId: number; settings: UserSettings }) =>
      apiClient.updateUserSettings(userId, settings),
    onSuccess: (updated) => {
      queryClient.setQueryData(userProfileKeys.me, updated);
    },
  });
};

export type { UserProfileDto, UserSettings };
